/// <reference path="../baseClasses/kiosk-base.ts" />

module Meevo.Components.Common {
    import KioskBase = Meevo.Components.BaseClasses.KioskBase;

    class KioskModeComponent extends KioskBase implements ng.IComponentController {
        static $inject = [
            'meevo.components.common.KioskModeLogic',
            'meevo.components.modal.ModalService',
            '$rootScope',
            '$scope',
        ];

        //#regionBindings
        header: string;
        logOutModalHeader: string;
        onClose: (response?: any) => void;
        skipReLogin: boolean;
        logout?: boolean;

        //#endregion

        constructor(protected kioskModelLogic: Meevo.Components.Common.KioskModeLogic,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected $rootScope: ng.IRootScopeService,
                    protected $scope: ng.IScope) {
            super(modalService, $rootScope, $scope, kioskModelLogic);
            // Listen for header update events
            this.$scope.$on('kioskHeaderUpdate', (event, newHeaderValue) => {
                console.log('Received kioskHeaderUpdate event with value:', newHeaderValue);
                this.header = newHeaderValue;
            });

        }

        close(response?: any): void {
            this.onClose(response);
        }

    }

    angular.module('meevo.components.common')
        .component('kioskModeComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/kioskModeComponent/kiosk-mode-component.html',
            controller: KioskModeComponent,
            controllerAs: '$ctrl',
            bindings: {
                header: '@',
                onClose: '&',
                logOutModalHeader: '@?',
                skipReLogin: '=?',
                logout: '=?'
            },
            transclude: {
                body: 'kioskBody',
                headerIcons: '?kioskHeaderIcons',
                headerLogo: '?kioskHeaderLogo'
            }
        });
}
